import React from "react";
import { node, string } from "prop-types";
import { classes } from "../utils/classes";
import Button from "../Button";

const InputGroupPrepend = ({ children }) => {
	return <div className="input-group-prepend">{children}</div>;
};

InputGroupPrepend.propTypes = {
	children: node.isRequired,
};

const InputGroupAppend = ({ children }) => {
	return <div className="input-group-append">{children}</div>;
};

InputGroupAppend.propTypes = {
	children: node.isRequired,
};

const InputGroupField = ({ children }) => children;

InputGroupField.propTypes = {
	children: node.isRequired,
};

const InputGroup = ({ children, className }) => {
	return <div className={classes("input-group", className)}>{children}</div>;
};

InputGroup.propTypes = {
	children: node.isRequired,
	className: string,
};

const InputGroupButton = ({ ...props }) => <Button styleType="input-group" size="s" {...props} />;

InputGroupButton.propTypes = {
	...Button.propTypes,
};

InputGroup.Prepend = InputGroupPrepend;
InputGroup.Append = InputGroupAppend;
InputGroup.Field = InputGroupField;
InputGroup.Button = InputGroupButton;

export default InputGroup;
